// couponActions.js — DealCouponz pattern: thunks → couponServices
import * as couponServices from "../../services/couponServices";
import * as couponTypes from "../types/couponTypes";

/** Sync merge (e.g. after vote / comment / like engagement APIs). */
export const mergeCoupon = (patch) => ({
  type: couponTypes.MERGE_COUPON,
  payload: patch,
});

export const getAllCoupons = () => async (dispatch) => {
  try {
    dispatch({ type: couponTypes.GET_ALL_COUPONS_REQUEST });
    const data = await couponServices.getAllCoupons();
    dispatch({ type: couponTypes.GET_ALL_COUPONS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: couponTypes.GET_ALL_COUPONS_FAILURE,
      payload: error?.message || "Failed to load coupons",
    });
  }
};

export const getCouponById = (id) => async (dispatch) => {
  try {
    dispatch({ type: couponTypes.GET_COUPON_BY_ID_REQUEST });
    const data = await couponServices.getCouponById(id);
    dispatch({ type: couponTypes.GET_COUPON_BY_ID_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: couponTypes.GET_COUPON_BY_ID_FAILURE,
      payload: error?.message || "Failed to load coupon",
    });
  }
};

export const getTrendingCoupons = (limit = 12) => async (dispatch) => {
  try {
    dispatch({ type: couponTypes.GET_TRENDING_COUPONS_REQUEST });
    const data = await couponServices.getTrendingCoupons(limit);
    dispatch({
      type: couponTypes.GET_TRENDING_COUPONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: couponTypes.GET_TRENDING_COUPONS_FAILURE,
      payload: error?.message || "Failed to load trending coupons",
    });
  }
};

export const getCouponsByCategorySlug = (slug) => async (dispatch) => {
  try {
    dispatch({ type: couponTypes.GET_COUPONS_BY_CATEGORY_SLUG_REQUEST });
    const data = await couponServices.getCouponsForCategorySlug(slug);
    dispatch({
      type: couponTypes.GET_COUPONS_BY_CATEGORY_SLUG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: couponTypes.GET_COUPONS_BY_CATEGORY_SLUG_FAILURE,
      payload: error?.message || "Failed to load category coupons",
    });
  }
};
